export default __webpack_public_path__ + "static/media/Dragon-e-Baby-Gone-Audible.64a4daed.jpg";